import { Redirect, Route, RouteProps } from 'react-router-dom';
import { loginRoute, noSicRoute } from '.';
import SplashScreen from '../components/Shared/SplashScreen/SplashScreen';
import AuthRequestStatus from '../enums/AuthRequestStatus';
import { AuthRoutesState } from '../types/AuthRoutesState';

interface Props extends RouteProps {
    authRoutesState: AuthRoutesState;
}

//this should ONLY be used for absolute basic "isLoggedIn" checks ie: for sic activation
export default function ActivateSicRoute({ authRoutesState, children, ...rest }: Props) {
    return (
        <Route
            {...rest}
            render={({ location }) => {
                /*
                    show an app loading screen while:
                    1. user has arrived on page and auth flow is yet to begin
                    2. OR app is checking/verifying auth from previous "session"
                    2. OR user has a valid auth from previous "session" AND app is requesting config
                */
                if (
                    authRoutesState.requestStatus === AuthRequestStatus.none ||
                    authRoutesState.requestStatus === AuthRequestStatus.verify ||
                    authRoutesState.requestStatus === AuthRequestStatus.authSuccess ||
                    (authRoutesState.hasReturningAuth &&
                        authRoutesState.requestStatus === AuthRequestStatus.active)
                ) {
                    return <SplashScreen status={authRoutesState.requestStatus} />;
                } else if (authRoutesState.requestStatus === AuthRequestStatus.configSuccess) {
                    //logged in
                    if (!authRoutesState.clientHasSic) {
                        return (
                            <Redirect to={{ pathname: noSicRoute, state: { from: location } }} />
                        );
                    }

                    //activate sic screen
                    if (
                        authRoutesState.dialerIsEnabled &&
                        !authRoutesState.dialerIsSic &&
                        authRoutesState.dialerIsSetup
                    ) {
                        return <>{children}</>;
                    }

                    return <Redirect to={{ pathname: '/', state: { from: location } }} />;
                } else {
                    //just show them the login screen
                    return <Redirect to={{ pathname: loginRoute, state: { from: location } }} />;
                }
            }}
        />
    );
}
